import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=bb604f0e&scoped=true&"
import script from "./Statistic.vue?vue&type=script&lang=js&"
export * from "./Statistic.vue?vue&type=script&lang=js&"
import style0 from "./Statistic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Statistic.vue?vue&type=style&index=1&id=bb604f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb604f0e",
  null
  
)

export default component.exports